import editableImageUploader from "./editableImageUploader.component";

const editableImageUploaderModule = angular
  .module("app.components.editableImageUploader", [])
  .component("editableImageUploader", editableImageUploader);

export default editableImageUploaderModule;



// WEBPACK FOOTER //
// ./src/components/editableImageUploader/editableImageUploader.module.js